import { useEffect, useRef, useState } from 'react';
import { Button } from 'antd';

const WorkOrderTiffViewer = () => {
  const canvasRef = useRef(null);
  const tiffRef = useRef(null);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const query = new URLSearchParams(window.location.search);
  const tiffUrl = query.get('tiffUrl');

  // Load TIFF when it's first opened
  useEffect(() => {
    if (tiffUrl) {
      fetch(tiffUrl)
        .then((response) => response.arrayBuffer())
        .then((buffer) => {
          const tiff = new window.Tiff({ buffer });
          tiffRef.current = tiff;
          setPageCount(tiff.countDirectory());
          setCurrentPage(0);
        })
        .catch((err) => console.error('Failed to load TIFF:', err));
    }
  }, [tiffUrl]);

  // Render current page
  useEffect(() => {
    const tiff = tiffRef.current;
    const canvas = canvasRef.current;
    if (tiff && canvas) {
      tiff.setDirectory(currentPage);
      const tiffCanvas = tiff.toCanvas();
      canvas.width = tiffCanvas.width;
      canvas.height = tiffCanvas.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(tiffCanvas, 0, 0, canvas.width, canvas.height);
    }
  }, [currentPage, pageCount]);

  return (
    <div style={{ width: '100vw', height: '100vh', background: '#000' }}>
      <canvas
        ref={canvasRef}
        style={{
          display: 'block',
          margin: '0 auto',
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      />
      {pageCount > 1 && (
        <div
          style={{
            position: 'absolute',
            bottom: 20,
            right: 20,
            background: 'white',
            padding: '15px 20px',
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            zIndex: 10,
          }}
        >
          <span style={{ color: '#000000' }}>
            Page {currentPage + 1} of {pageCount}
          </span>
          <Button
            type="primary"
            onClick={() => setCurrentPage((p) => Math.max(0, p - 1))}
            disabled={currentPage === 0}
          >
            Previous
          </Button>
          <Button
            type="primary"
            onClick={() =>
              setCurrentPage((p) => Math.min(pageCount - 1, p + 1))
            }
            disabled={currentPage === pageCount - 1}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
};

export default WorkOrderTiffViewer;
